import { logger } from './logger';
import { convertInputBufferToString } from './convert-input-buffer-to-string';
import debounce from 'lodash.debounce';
import { HotkeyDisplayService } from '../hotkey-display-service';

export const HANDLER_PIPELINE_DELAY = 200;

export const runHandlerPipeline = debounce(
  (rule, inputBuffer, event, onSuccess) => {
    const { hotkeyReference, handler } = rule;
    const hotKeyString = convertInputBufferToString(inputBuffer);
    logger.log('Successful hotkey match ', hotKeyString, ' for ', rule);
    const displayHotkeyReference = handler(inputBuffer, event);
    // HotkeyDisplayService normally displays its little popup pill for
    // any matched hotkey, but in the case of us wanting to override a
    // hotkey to noop it or swap in another hotkey handler, we may want
    // to also squash the display of that pill. Returning an explicit
    // false value from your handler will now do exactly that.
    if (displayHotkeyReference !== false) {
      HotkeyDisplayService.showHotkey(hotkeyReference);
    }
    // TODO: - Analytics
    onSuccess(hotkeyReference, hotKeyString);
  },
  HANDLER_PIPELINE_DELAY,
  { leading: true, trailing: false },
);
